// The General tab's constants, and a profile to test against.
//
// The name is now a misnomer and kept only because half the feature imports
// from it: the tab is served by `/api/v1/settings/` and nothing here stands in
// for an answer any more. What is left is what the photo picker enforces, the
// empty profile a first visit opens on, and `SAMPLE_PROFILE`, which is a
// fixture the suites share rather than anything the app reads.
//
// The two option lists that used to sit here have moved to `profileCodes`,
// where they are derived from the codes the API actually keeps — a label and
// the code behind it cannot then drift apart.

import type { DietitianProfile } from "../types/settings.types";

/** What the photo picker accepts, as the hint under it states them. */
export const ACCEPTED_PHOTO_TYPES = ["image/jpeg", "image/png", "image/gif"];

/** The same list as an `accept` attribute, so the file dialog filters too. */
export const ACCEPTED_PHOTO_ATTR = ACCEPTED_PHOTO_TYPES.join(",");

/** 2MB, which is what the hint under the picker promises. */
export const MAX_PHOTO_BYTES = 2 * 1024 * 1024;

/** A profile nothing has been filled into — what a first visit would open on. */
export const emptyProfile: DietitianProfile = {
  salutation: "",
  firstName: "",
  lastName: "",
  gender: "",
  age: "",
  photo: null,
  active: true,
  address: "",
  state: "",
  city: "",
  pincode: "",
  phone: "",
  whatsapp: "",
  whatsappSameAsPhone: false,
  experienceYears: "",
  experienceMonths: "",
  specializations: [],
};

/** A filled-in profile for the suites — nothing in the app reads it. */
export const SAMPLE_PROFILE: DietitianProfile = {
  salutation: "Mrs",
  firstName: "Sonam",
  lastName: "Patil",
  gender: "Female",
  age: "32",
  photo: null,
  active: true,
  address: "1202 Galaxy Apartment, SV Road Malad West",
  state: "Maharashtra",
  city: "Mumbai",
  pincode: "400064",
  phone: "9876543210",
  whatsapp: "9876543210",
  whatsappSameAsPhone: true,
  experienceYears: "8",
  experienceMonths: "0",
  specializations: [
    "Weight management",
    "Diabetic nutrition",
    "Renal health",
    "Sports nutrition",
  ],
};
